import React from "react";
import "./ErrorMessage.scss";

const FormErrorMessage = ({
  error,
  id,
  messages = {},
  icon = false,
  className = "",
  position = "absolute",
}) => {
  // Return nothing if error is falsy
  if (!error) return null;

  // Determine message safely
  const message =
    (error?.message && error.message) || messages[error?.type] || "Error in field";

  return (
    <span
      className={`text-danger danger_mob d-flex align-items-center fs-12 fw-500 ${className}`}
      id={id}
      style={{ textTransform: "", position }}
    >
      {icon && <span className="error-icon mr-1">!</span>}
      {message}
    </span>
  );
};

export default FormErrorMessage;
